/* eslint-disable react/no-array-index-key */
import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { SelectableOptionButton } from "../SelectableOptionButton/SelectableOptionButton";

export type SelectableListProps = {
  options?: string[] | boolean[] | number[] | any;
  disabled?: boolean;
  onChange?: (value: string | string[] | boolean | number | undefined) => void;
  value?: string | string[] | boolean | number | any | undefined;
  splitted?: boolean;
  multiple?: boolean;
  columns?: "1" | "2" | "3";
};

export function SelectableOptionsList(props: SelectableListProps) {
  const { t } = useTranslation();

  return (
    <div>
      {props.multiple && (
        <p className="text-xs mb-1">{t("common.multipleSelection")}</p>
      )}

      <div
        className={clsx(
          "grid flex-1 w-full",
          props.columns === "1" && "grid-cols-1",
          props.columns === "2" && "grid-cols-2",
          (!props.columns || props.columns === "3") && "grid-cols-3",
          props.splitted && "gap-2 flex-wrap"
        )}
      >
        {props.options?.map((item: any, index: number) => {
          const isFirst = index === 0;
          const isLast = index === props.options.length - 1;

          return (
            <SelectableOptionButton
              value={item?.value}
              label={item.label ? item.label : undefined}
              selectedValue={props.value}
              onChange={props.onChange}
              isFirstElementInTheList={isFirst}
              isLastElementInTheList={isLast}
              disabled={props.disabled}
              key={index}
              splitted={props.splitted}
              multiple={props.multiple}
            />
          );
        })}
      </div>
    </div>
  );
}
